'use client';

import { AuthProvider } from '@/hooks/useAuth';

export function AuthProviderWrapper({ children }: { children: React.ReactNode }) {
  return <AuthProvider data-component-id="src/components/providers/AuthProviderWrapper.tsx:6:9" data-component-path="src/components/providers/AuthProviderWrapper.tsx" data-component-line="6" data-component-end-line="6" data-component-file="AuthProviderWrapper.tsx" data-component-name="AuthProvider" data-component-content="%7B%22elementName%22%3A%22AuthProvider%22%7D">{children}</AuthProvider>;
}
